import { defineStore } from 'pinia';

const useSchoolSearchStore = defineStore(
  'schoolSearchStore',
  {
    state: () => (
      {
        key: 0,
        selectedMarket: null,
        isOptionSelected: null,
        searchResult: {
          schools: [],
          message: '',
          suggestions: [],
          unrecognizedTerms: [],
        },
        selectedSchool: {},
      }
    ),
    getters: {
      searchResultSchools() {
        return this.searchResult.schools;
      },
      searchResultsMessages() {
        return {
          message: this.searchResult.message,
          suggestions: this.searchResult.suggestions,
          unrecognizedTerms: this.searchResult.unrecognizedTerms,
        }
      },
      selectedSchoolId() {
        return this.selectedSchool.id;
      }
    },
    actions: {
      /**
       * Updates the state with results from the school search call.
       * @param {Object} results
       */
      setSchoolSearchResults(results) {
        const searchResults = results.search_results;
        this.searchResult.schools = searchResults.schools;

        // Guard against a null/undefined value for searchResult.schools.
        this.searchResult.schools?.map((item) => {
          item.text = item.label;
        });
        this.key++;
        this.searchResult.message = searchResults.message;
        this.searchResult.suggestions = searchResults.suggestions;
        this.searchResult.unrecognizedTerms = searchResults.unrecognized_search_terms;
      },
      resetSearchState() {
        this.searchResult.schools = [];
        this.isOptionSelected = false;
      },
      storeSelectedSchool(selectedSchool) {
        this.isOptionSelected = selectedSchool != null;
        this.selectedSchool = JSON.parse(selectedSchool);
      },
    }
  }
);
export default useSchoolSearchStore;
